import React from 'react';
import { observer } from 'mobx-react-lite';
import { BET_ACTION_MODAL_TYPE } from '../../enums/betActionModal';
import { autoBetStore } from '../../store/autoBetStore';

export const AutoBetPopUp = observer(({ isShowBetActionModal, handleShowBetActionModal, isMobile }) => {

  const {autoBetModel} = autoBetStore;
  const count = autoBetModel ? autoBetModel.autoBetCount + 1 : ''

  return (
    <div
      className={`${isMobile() ? 'mob-roulette-t-icon-item' : 'right-top-icon-box'} 
                  ${isShowBetActionModal === BET_ACTION_MODAL_TYPE.reBet ? 'active' : ''}`}
      onClick={() => handleShowBetActionModal(BET_ACTION_MODAL_TYPE.reBet)}
    >
          <span className="icon-autoplay"/>
      {
        autoBetModel && <>
          <div className="favorite-number-web">{count}</div>
        </>
      }
    </div>
  );
});